import React, { useState } from "react";
import { useRoutes } from "react-router-dom";
import { ToastContainer, Bounce } from "react-toastify";
import routes from "./routes";
import "./App.css";
import "react-toastify/dist/ReactToastify.css";

export default function App() {
  const router = useRoutes(routes);
  return (
    <>
      {router}
      <ToastContainer
        className="!w-[350px] md:w-auto font-Dana"
        position="top-right"
        autoClose={4998}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick={false}
        rtl
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="dark"
        transition={Bounce}
        toastStyle={{ FontFace: "Dana" }}
        style={{
          position: "fixed",
          zIndex: 9999,
          top: "80px",
          right: "20px",
        }}
      />
    </>
  );
}
